module.exports = __webpack_public_path__ + "static/media/quote-roosevelt-caring.8292507f.png";